import { DocumentNew } from './view';

export { default as DocumentNewReducer } from './reducer';
export { default as DocumentNewSaga } from './saga';

export default DocumentNew;
